import React, { Component } from 'react';
import { Modal, Icon, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { TitledCard } from 'Components/';
import {
  ING_MEASUREMENTS_FORM_NAME,
  ING_PURCHASING_FORM_NAME,
} from 'Common/FormEnum';
import { DEFAULT_ACCOUNT_CATEGORY_ID } from 'Common/Constants/inventory';
import * as Selectors from 'Pages/manageingredient/state/editingredient/selectors';
import {
  IngPurchasingFieldEnum,
  IngMeasurementsFieldEnum,
} from 'Common/FieldEnum';
import { WEIGHT_UNITS } from 'Pages/manageingredient/helpers/Constants';

import { MeasuresAndCostForm } from './MeasuresAndCostForm';
import { InventoryPurchasingUnitForm } from './InventoryPurchasingUnitForm';

class MeasurementsAndPurchasingModal extends Component {
  submitSuccess = 0;

  onClose = () => {
    this.submitSuccess = 0;
    const { submit } = this.props;
    submit(ING_MEASUREMENTS_FORM_NAME);
    submit(ING_PURCHASING_FORM_NAME);
  };

  onSubmit = () => {
    this.submitSuccess += 1;
    if (this.submitSuccess > 1) {
      this.props.modalProps.onClose();
    }
  };

  get initialValues() {
    const { ingredientId } = this.props;

    const hasIngredientId = Boolean(ingredientId);

    if (hasIngredientId) {
      return {
        [IngMeasurementsFieldEnum.Measures]: [],
      };
    }
    return {
      [IngMeasurementsFieldEnum.Measures]: [
        {
          [IngMeasurementsFieldEnum.Amount]: '',
          [IngMeasurementsFieldEnum.Measurement]: '',
          [IngMeasurementsFieldEnum.Weight]: '',
          [IngMeasurementsFieldEnum.BaseMeasure]: WEIGHT_UNITS.GRAMS,
          [IngMeasurementsFieldEnum.IsDefault]: true,
        },
      ],
    };
  }

  render() {
    const {
      isReadOnly,
      modalProps,
      measures,
      costPerGram,
      ingredientName,
      isCreatedFromRecipe,
      isInventoryLicensed,
    } = this.props;

    return (
      <div className="measurements-purchasing-modal">
        <Modal {...modalProps}>
          <Modal.Header className="manage-menu-modal-header">
            <span>{ingredientName}</span>
            <Icon
              name="close"
              onClick={this.onClose}
              className="manage-menu-close"
            />
          </Modal.Header>
          <Modal.Content className="manage-menu-modal-content">
            <React.Fragment>
              <TitledCard title="Weights & Measures">
                <MeasuresAndCostForm
                  isReadOnly={isReadOnly || isCreatedFromRecipe}
                  initialValues={this.initialValues}
                  onSubmit={this.onSubmit}
                  measures={measures}
                  costPerGram={costPerGram}
                />
              </TitledCard>
              <TitledCard title="Inventory & Purchasing Unit">
                <InventoryPurchasingUnitForm
                  initialValues={{
                    [IngPurchasingFieldEnum.PrimaryPrice]: '',
                    [IngPurchasingFieldEnum.Unit]: '',
                    [IngPurchasingFieldEnum.QtyPerUnit]: '',
                    [IngPurchasingFieldEnum.SecondaryUnit]: '',
                    [IngPurchasingFieldEnum.SecondaryUnitWeight]: '',
                    [IngPurchasingFieldEnum.SecondaryUnitMeasure]: '',
                    [IngPurchasingFieldEnum.INV_ItemId]: '',
                    [IngPurchasingFieldEnum.AccountCategoryId]: DEFAULT_ACCOUNT_CATEGORY_ID,
                    [IngPurchasingFieldEnum.VendorId]: '',
                  }}
                  onSubmit={this.onSubmit}
                  isReadOnly={isReadOnly}
                  isInventoryLicensed={isInventoryLicensed}
                />
              </TitledCard>
            </React.Fragment>
          </Modal.Content>
          <Modal.Actions>
            <Button type="button" onClick={this.onClose}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  measures: Selectors.getFormMeasures(state),
  costPerGram: Selectors.getCostPerGram(state),
  ingredientName: Selectors.getIngredientName(state),
});

const mapDispatchToProps = {
  submit,
};

MeasurementsAndPurchasingModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(MeasurementsAndPurchasingModal);

export { MeasurementsAndPurchasingModal };



// WEBPACK FOOTER //
// ./src/pages/manageingredient/subpages/editingredient/components/MeasurementsAndPurchasingModal.js